import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import ruby from '../assets/ruby.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

export default {
  email,
  mobile,
  css,
  figma,
  git,
  html,
  javascript,
  react,
  redux,
  sass,
  ruby,
  profile,
  circle,
  logo,
};
